import { render, staticRenderFns } from "./BeratungsauftragLeistungenListe.vue?vue&type=template&id=201d4878&"
import script from "./BeratungsauftragLeistungenListe.vue?vue&type=script&lang=js&"
export * from "./BeratungsauftragLeistungenListe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports